

<template>
  <div class="mianHome">
    <!-- 开启顶部安全区适配 -->
    <!-- <van-nav-bar safe-area-inset-top /> -->
    <RouterView />

    <!-- 开启底部安全区适配 -->
    <van-number-keyboard safe-area-inset-bottom />


    <div class="openinstall_shadow" v-if="showMask" @click="changeMask">
      <div class="mask-img">
        <img src="@/assets/image/android-brower-tip.png" alt="">
      </div>
    </div>
  </div>
</template>

<script setup>
  import { ref} from 'vue';

  const showMask = ref(false);

  function isBrowser() {
    var ua = navigator.userAgent.toLowerCase();
    return ua.indexOf('qq/') !== -1 || ua.indexOf('micromessenger') !== -1;
  }

  if(window.browserMask === 1 && isBrowser()) {
    showMask.value = true;
  }

  const changeMask = ()=> {
    showMask.value = false;
  }

</script>


<style lang="less" scoped>

.mianHome{
    width: 750px;
    height: 100%;
}

.openinstall_shadow {
  position: fixed;
  left: 0;
  top: 0;
  background: rgba(0, 0, 0, 0.5);
  width: 100%;
  height: 100%;
  z-index: 10000;
  .mask-img {
    text-align: right;
    margin-top: 1%;
    margin-right: 5%;
    img {
      width: 70%;
      margin: 0 auto;
    }
  }
}
</style>
